export default __webpack_public_path__ + "static/media/Story.dfde92a2.jpg";